const Events = {
	listeners: {},
	throttlers: {},
	debug: false,

	on: on,
	off: off,
	trigger: trigger,
	triggerThrottle: triggerThrottle
};

function on(names, callback){
	if(typeof callback === "function"){
		const that = this;
		names = names.trim().split(' ');
		names.forEach(function(fullname){
			const nameParts = fullname.split('.'),
				eventName = nameParts[0],
				namespace = nameParts[1];
			if(eventName == "*"){
				console.log("Warning when calling '.on()': Event Wildcards are ignored!");
				return;
			}
			if(!that.listeners[eventName]){
				that.listeners[eventName] = [];
			}
			that.listeners[eventName].push({
				namespace: namespace || '',
				callback: callback
			});
		});
	}else{
		console.log("Error when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
	}
	return this;
}

function off(names, callback){
	if(!names){
		console.log("Error when calling '.off()': Invalid event name supplied");
		return this;
	}
	const that = this;

	names = names.trim().split(' ');
	names.forEach(function(fullname, key){
		const nameParts = fullname.split('.'),
			eventName = nameParts[0],
			namespace = nameParts[1],
			removeList = eventName === '*' ? Object.keys(that.listeners) : [eventName];
		removeList.forEach(function(remove){
			const list = that.listeners[remove] || [];
			let i = list.length;
			while(i--){
				var listener = list[i];
				if(listener && (namespace === listener.namespace || namespace === '*') && (!callback || callback === listener.callback)){
					list.splice(i, 1);
				}
			}
			if(!list.length){
				delete that.listeners[remove];
			}
		});
	});
	return this;
}

function trigger(name, vars){
	if(!name){
		console.log("Error when calling '.trigger()': Invalid event name supplied");
		return this;
	}
	const nameParts = name.split('.'),
		eventName = nameParts[0],
		namespace = nameParts[1],
		listeners = this.listeners[eventName];

	if(this.debug){
		console.log('Event fired:', eventName, vars ? '->' : '', vars || '');
	}

	if(!listeners){
		return this;
	}

	listeners.forEach(function(listener, key){
		if(!namespace || namespace === listener.namespace){
			listener.callback.call(null, {
				type: eventName,
				namespace: namespace,
				vars: vars
			});
		}
	});
	return this;
}

function triggerThrottle(name, vars){
	if(!name){
		console.log("Error when calling '.triggerThrottle()': Invalid event name supplied");
		return this;
	}

	if(!this.throttlers[name]){
		this.throttlers[name] = false;
	}

	const func = function(){
		if(this.throttlers[name]){
			return;
		}

		this.throttlers[name] = true;

		const trigger = function(){
			this.trigger(name, vars);
			this.throttlers[name] = false;
		}

		requestAnimationFrame(trigger.bind(this));
	}

	func.call(this);
}

function createEvents(){
	return Object.create(Events);
}

export {Events, createEvents};



// WEBPACK FOOTER //
// ./resources/assets/js/src/util/events.js